// extracted by mini-css-extract-plugin
export var error = "shared-module--error--8a857";
export var input = "shared-module--input--2260b";
export var wrapper = "shared-module--wrapper--4cc86";